import { useQuery } from '@tanstack/react-query'
import { notificationsQueryKeys } from '../constants'
import api from '../../config/axios-config'
/**
 * Fetches current email frequency settings for notification emails.
 * @param {Object} options - Additional options for `useQuery`.
 * @returns {Object} - Query result containing the current notification settings.
 * Endpoint:
 * Frontend proxy: GET /api/notificationSettings
 * Important details:
 * This query is kept in sync by `useUpdateEmailFrequencyMutation`, which updates the cache on success.
 */

export const useGetEmailFrequencyQuery = (options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api(`/api/notificationSettings`, config)

    return data
  }

  return useQuery({
    queryKey: [notificationsQueryKeys.NOTIFICATIONS_GET_EMAIL_FREQUENCY],
    queryFn: handleQuery,
    ...options
  })
}
